// const endpoint = method => `http://localhost:5001/zak-fisher-2019/us-central1/api/${method}`;
const endpoint = method => `https://us-central1-zak-fisher-2019.cloudfunctions.net/api/${method}`;
export default endpoint;



// WEBPACK FOOTER //
// ./src/helpers/endpoint.js